export default {
  en: {
    pcs: 'pcs',
    select: 'Select',
    startDate: 'Start date',
    endDate: 'End date',
    cashier: 'Cashier',
    salesRep: 'Sales Rep',
    qrStyleMinimal: 'Minimal',
    qrStyleProfessional: 'Professional',
    qrStyleFun: 'Fun',
    qrStyleColorful: 'Colorful',
    receiptDesignClassic: 'Modern',
    receiptDesignRxPad: 'Rx Pad',
    printSectionsFilled: 'Only filled sections',
    printSectionsAll: 'All sections',
    qrStyleView: 'View',
    qrStylePreviewTitle: 'Saved QR image preview',
    qrStyleUse: 'Use this style',
    qrStyleClose: 'Close',
    idCardStyleClassic: 'Classic',
    idCardStyleModern: 'Modern',
    idCardStylePreviewTitle: 'ID card preview',
    cylNotationMinus: 'Minus cylinder (−cyl)',
    cylNotationPlus: 'Plus cylinder (+cyl)',
    'Full Name': 'Full Name',
    'Only first 2 names': 'Only first 2 names',
    noDataAvailable: 'No data available',
    suggestionDeleted: 'Suggestion deleted successfully',
    deleteFailed: 'Failed to delete suggestion',
    errors: {
      system: {
        code: 'Error code',
        unexpectedErr: 'Unexpected system error',

        http: {
          unexpectedResponse: 'Server error: please contact support',
          serverNotResponding: "Server isn't responding: restart server or contact support",
          failedToConnectToServer: 'Failed to connect to server: please contact support'
        }
      },

      client: {
        tabs: {
          maxNumExceeded: 'cannot open more than {tabsNum} tabs',
          cannotCloseMainWindow: 'Cannot close main window'
        },

        accessControl: {
          unauthorized: 'Action unauthorized',
          lt: 'Action unauthorized: {lhs} must be less than {rhs}',
          lte: 'Action unauthorized: {lhs} must be less than or equal to {rhs}',
          eq: 'Action unauthorized: {lhs} must be equal to {rhs}',
          nq: 'Action unauthorized: {lhs} must not be equal to {rhs}',
          gt: 'Action unauthorized: {lhs} must be greater than {rhs}',
          gte: 'Action unauthorized: {lhs} must be greater than or equal to {rhs}'
        },
        itemSerializedAndUnlimitedError: "item can't be serialized and unlimited at the same time"
      }
    },

    actions: {
      saveChanges: 'Save changes',
      save: 'Save',
      saveChangesSuccess: 'Changes were successfully saved',
      clearButton: 'Clear fields',
      print: 'Print',
      generateReport: 'Generate Report',
      newSale: 'New Sale',
      newReturn: 'New Return',
      newExam: 'New Exam'
    },

    models: {
      common: {
        id: 'ID',
        date: 'Date',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
        deletedAt: 'Deleted at',
        time: 'Time',
        label: 'Key',
        value: 'Value'
      }
    },

    validation: {
      inputErrors: 'Input errors',
      required: "Can't leave field empty",
      minLength: '{field} must have length at least {len}',
      maxLength: 'must have length less than {len}',
      positive: '{field} must have a positive value',
      nonNegative: '{field} must have a value >= 0',
      unsupportedImage: 'unsupported image type',
      matchingLength: '{thisField} must have a length equal to {thatField}'
    },

    views: {
      common: {
        listView: {
          quickView: 'Quick View',
          allItems: 'All Items',
          deletedItems: 'Deleted Items',
          view: 'View',
          edit: 'Edit',
          selectedRows: {
            options: 'Selected rows options...',
            delete: 'Delete selected rows',
            deleteConfirm: 'Are you sure you want to delete selected rows?',
            deleteSuccess: 'The selected rows have been deleted',
            export: 'Export selected rows',
            exportSuccess: 'Selected rows were successfully exported',
            restore: 'Restore selected rows',
            restoreConfirm: 'Are you sure you want to restore selected rows?',
            restoreSuccess: 'The selected rows have been restored',
            deletePermanently: 'Delete permanently',
            deletePermanentlyConfirm: 'Are you sure you want to delete the selected rows permanently?',
            deletePermanentlySuccess: 'The selected rows have been deleted permanently'
          },

          searchRows: 'Search rows',
          count: 'Total # of rows'
        }
      },

      backups: {
        backups: "Backups",
        backupName: "Backup Name",
        downloadBackup: "Download Backup",
        deleteBackup: "Delete Backup",
        createBackup: "Create Backup"
      },

      home: {
        home: 'Home'
      },

      login: 'Login',

      sales: {
        sales: 'Sales',
        newSale: 'New Sale',
        orderPayment: 'Order Payment',
        receipt: 'Receipt',
        orders: {
          orders: 'Orders',
          order: 'Order',
          returnOrder: 'Return Order',
          orderPayment: 'Order Payment'
        },
        registers: {
          openRegister: 'Open Register',
          closeRegister: 'Close Register'
        },
        quotes: {
          quotes: 'Quotes'
        },
        transactions: {
          transactions: 'Transactions'
        }
      },

      inventory: {
        inventory: 'Inventory',

        items: {
          items: 'Items',
          newSimpleItem: 'New Item',
          simpleItem: 'Edit Item',
          import: 'Import Items',
          itemBatches: 'Item Batches',
        },

        transactions: {
          transactions: 'Inventory Transactions',
        },

        brands: {
          brands: 'Brands',
          newBrand: 'new Brand',
          brand: 'Edit Brand'
        },

        customPrice: {
          customPrices: 'Custom Prices',
          newCustomPriceType: 'New Custom Price Type'
        },

        packs: {
          packs: 'Packs',
          newPack: 'New Pack'
        },

        attribute: {
          attributes: 'Attributes',
          newAttribute: 'New Attribute'
        },

        categories: {
          categories: 'Categories',
          newCategory: 'New Category',
          category: 'Category'
        },

        tags: {
          tags: 'Tags',
          newTag: 'New Tag',
          tag: 'Edit Tag'
        },

        inventoryReceivings: {
          inventoryReceivings: 'Inventory Receivings',
          newInventoryReceiving: 'New Inventory Receiving',
          inventoryReceiving: 'Inventory Receiving'
        },

        inventoryAdjustments: {
          inventoryAdjustments: 'Inventory Adjustments',
          newInventoryAdjustment: 'New Inventory Adjustment',
          inventoryAdjustment: 'Inventory Adjustment'
        },

        missingSerials: {
          missingSerials: 'Missing Serials',
        },

        itemBatches: {
          itemBatches: 'Item Batches',
        },

        purchaseOrders: {
          purchaseOrders: 'Purchase Orders',
          newPurchaseOrder: 'New Purchase Order',
        },

        inventoryTransfers: {
          inventoryTransfers: 'Inventory Transfer',
          newInventoryTransfer: 'New Inventory Transfer',
          receiveInventoryTransfer: 'Receive Inventory Transfer',
          inventoryTransfer: 'Inventory Transfer'
        },

        inventoryReturnToVendors: {
          inventoryReturnToVendors: 'Inventory Return'
        },

        printBarcode: {
          printBarcode: 'Print Barcode'
        }
      },

      customers: {
        customers: 'Customers',
        newCustomer: 'New Customer',
        editCustomer: 'Edit Customer',
        customer: 'Edit Customer',
        birthdays: 'Birthdays',
        documentation: 'Notes',
        notes: {
          notes: 'Notes',
        },
      },

      pets: {
        pets: 'Pets',
        newPet: 'New Pet',
        pet: 'Edit Pet',
        viewPet: 'View Pet'
      },

      vets: {
        newVetService: 'New Vet Service',
      },

      vetServices: {
        vetServices: 'Vet Services',
        newVetService: 'New Vet Service',
        vetService: 'Edit Vet Service'
      },

      examinations: {
        examinations: 'Examinations',
        newExamination: 'New Examination',
        zeissCards: 'ZEISS Cards',
        newZeissCard: 'New ZEISS Card',
        zeissCardsPage: {
          settings: 'Settings',
          newCard: 'New Card'
        }
      },

      appointments: {
        appointments: 'Appointments',
        newAppointment: 'New Appointment'
      },

      companies: {
        companies: 'Companies',
        vendors: {
          vendors: 'Vendors',
        },
        deliveries: {
          deliveries: 'Deliveries',
        },
      },

      vendors: {
        vendors: 'Vendors',
        newVendor: 'New Vendor',
        vendor: 'Edit Vendor'
      },
      insurances: {
        insurances: 'Insurance',
        newInsurance: 'New Insurance company',
        insurance: 'Edit Insurance company'
      },

      deliveries: {
        deliveries: 'Delivery',
        newDelivery: 'New Delivery company',
        delivery: 'Edit Delivery company'
      },

      hr: {
        hr: 'HR',
        viewSchedule: 'View Schedule',
        assignShift: 'Assign Shift',
        employees: {
          employees: 'Employees',
          newEmployee: 'New Employee'
        },
        roles: {
          roles: 'Roles'
        },
        commissions: {
          commission: 'Commission',
          newCommission: 'New Commission'
        },
        moneyCollectorCommissions: {
          moneyCollectorCommissions: 'Money Collector Commissions',
          new: 'New Money Collector Commission'
        },
        employeeSchedule: {
          employeeSchedule: 'Employee Schedule',
          newEmployeeSchedule: 'New Employee Schedule'
        },
        tasks: {
          tasks: 'Tasks',
        },
        employeeSchedules: {
          newEmployeeSchedule: 'New Schedule',
        },
        clockInOut: 'Clock In/Out',
        myTasks: 'My Tasks'
      },

      accounting: {
        accounting: 'Accounting',

        accounts: {
          accounts: 'Accounts',
          account: 'Account Info',
          newAccount: 'New Account'
        },

        transactions: {
          transactions: 'Transactions',
          transaction: 'Transaction Info',
          newTransaction: 'New Transaction'
        },

        vendors: {
          newBill: 'New Bill'
        },
        company: {
          company: 'Company',
          newExpense: 'New Expense'
        },
        safesAndBanks: {
          safesAndBanks: 'Safes & Banks',
        },
      },

      reports: {
        reports: 'Reports',
        agGridToolbar: {
          fromDate: 'From Date',
          toDate: 'To Date'
        },
        emptyState: 'try different store or date',
        salesSummary: {
          salesSummaryNoSales: {
            title: 'Sales Summary By Number Of Sales',
            noOfSales: '# Of Sales',
            noOfReturns: '# Of Returns'
          },
          salesSummaryValues: {
            title: 'Sales Summary By Sales Values',
            totalSales: 'Total Sales',
            totalReturns: 'Total Returns',
            netSales: 'Net Sales'
          }
        }
      },
      settings: {
        settings: 'Settings',
        tabs: {
          printers: 'Printers',
          receipt: 'Receipt size',
          currencies: 'Currencies',
          language: 'Language',
          license: 'License',
          sales: 'Sales'
        }
      },

      notifications: {
        title: 'Notifications',
        unread: 'unread',
        empty: 'No notifications today',
        allCaughtUp: 'You\'re all caught up',
        loadMore: 'Load more',
        noneForDay: 'No notifications for this day',
        markAllRead: 'Mark all as read',
        viewAll: 'View all notifications',
        all: 'All',
        read: 'Read',
        reminders: 'Reminders',
        searchPlaceholder: 'Search Notifications',
        types: {
          appointment: 'Appointment',
          task: 'Task',
          birthday: 'Birthday',
          quote: 'Quote',
          reminder: 'Reminder',
          order_due: 'Order Due'
        },
        repeat: {
          none: 'None',
          hourly: 'Hourly',
          daily: 'Daily',
          weekly: 'Weekly',
          monthly: 'Monthly'
        },
        reminder: {
          addTitle: 'Add Reminder',
          editTitle: 'Edit Reminder',
          titleLabel: 'Title',
          noteLabel: 'Note',
          dateTimeLabel: 'Date & Time',
          repeatLabel: 'Repeat',
          markDone: 'Done',
          delete: 'Delete',
          deleteConfirm: 'Delete this reminder?'
        }
      }
    },

    dialogs: {
      warning: 'Warning',
      confirm: 'Confirm',
      cancel: 'Cancel',
      completePay: 'Process Payment',
      enterCashierPin: 'Enter cashier pin',
      errCashierPinRequired: 'Cashier pin is required',
      confirmAction: 'Are you sure?',
      msgUpdated: 'System Updated',
    },
    update: 'Update',
    components: {
      tagInput: {
        placeholder: 'Press Enter after adding each value'
      }
    }
  },
  ar: {
    pcs: 'قطعة',
    select: 'اختر',
    startDate: 'من تاريخ',
    endDate: 'الى تاريخ',
    cashier: 'الكاشير',
    salesRep: 'ممثل البيع',
    qrStyleMinimal: 'بسيط',
    qrStyleProfessional: 'احترافي',
    qrStyleFun: 'مرح',
    qrStyleColorful: 'ملوّن',
    receiptDesignClassic: 'التصميم الحديث',
    receiptDesignRxPad: 'تصميم الوصفة الطبية (Rx Pad)',
    printSectionsFilled: 'الأقسام المملوءة فقط',
    printSectionsAll: 'جميع الأقسام',
    qrStyleView: 'عرض',
    qrStylePreviewTitle: 'معاينة صورة رمز QR',
    qrStyleUse: 'استخدام هذا التصميم',
    qrStyleClose: 'إغلاق',
    idCardStyleClassic: 'كلاسيكي',
    idCardStyleModern: 'عصري',
    idCardStylePreviewTitle: 'معاينة البطاقة',
    cylNotationMinus: 'سالبة (-cyl)',
    cylNotationPlus: 'موجبة (+cyl)',
    'Full Name': 'الاسم الكامل',
    'Only first 2 names': 'اول اسمين فقط',
    noDataAvailable: 'لا توجد بيانات متاحة',
    suggestionDeleted: 'تم حذف الاقتراح بنجاح',
    deleteFailed: 'فشل حذف الاقتراح',
    errors: {
      system: {
        code: 'خطأ رقم',
        unexpectedErr: 'خطأ غير متوقع في النظام',

        http: {
          unexpectedResponse: 'خطأ في الخادم: يرجى الاتصال بوحدة الدعم',
          serverNotResponding:
            'تعذر الرد من الخادم: يرجى اعادة تشغيل الخادم او الاتصال بوحدة الدعم',
          failedToConnectToServer: 'تعذر الاتصال بالخادم: يرجى الاتصال بوحدة الدعم'
        }
      },

      client: {
        tabs: {
          maxNumExceeded: 'لايمكنك اضافة نافذة جديدة. العدد الاقصى للنوافذ هو {tabsNum}',
          cannotCloseMainWindow: 'لايمكنك اغلاق النافذة الرئيسية'
        },

        accessControl: {
          unauthorized: 'ليس لديك الصلاحية لهذه العملية',
          lt: '@:errors.client.accessControl.unauthorized: يجب ان تكون قيمة {lhs} ادنى من {rhs}',
          lte: '@:errors.client.accessControl.unauthorized: يجب ان تكون قيمة {lhs} ادنى من او تساوي {rhs}',
          eq: '@:errors.client.accessControl.unauthorized: يجب ان تكون قيمة {lhs} مساوية {rhs}',
          nq: '@:errors.client.accessControl.unauthorized: يجب ان تكون قيمة {lhs} لايمكن ان تساوي {rhs}',
          gt: '@:errors.client.accessControl.unauthorized: يجب ان تكون قيمة {lhs} اعظم من {rhs}',
          gte: '@:errors.client.accessControl.unauthorized: يجب ان تكون قيمة {lhs} اعظم من او تساوي {rhs}'
        },
        itemSerializedAndUnlimitedError: "العنصر لايمكن ان يكون غير محدود ومتسلسل بنفس الوقت"
      }
    },

    actions: {
      saveChanges: 'حفظ البيانات',
      save: 'حفظ',
      saveChangesSuccess: 'تم حفظ التعديلات بنجاح',
      clearButton: 'تفريغ الحقول',
      print: 'إطبع',
      generateReport: 'انشاء التقرير',
      newSale: 'بيع جديد',
      newReturn: 'ارجاع جديد',
      newExam: 'فحص جديد'
    },

    models: {
      common: {
        id: 'ID',
        date: 'التاريخ',
        createdAt: 'تاريخ الانشاء',
        updatedAt: 'تاريخ التحديث',
        deletedAt: 'تاريخ الحذف',
        time: 'الوقت',
        label: 'الحقل',
        value: 'القيمة'
      }
    },

    validation: {
      inputErrors: 'اخطاء الادخال',
      required: 'لايمكن ترك الحقل فارغا',
      minLength: 'يجب ان يكون طول الحقل على الاقل {len}',
      maxLength: 'يجب ان يكون طول الحقل اقل من {len}',
      positive: 'يجب ان تكون قيمة {field} موجبة',
      nonNegative: '{field} يجب ان تكون قيمته >= 0',
      unsupportedImage: 'صيغة الصورة غير مدعومة',
      matchingLength: '{thisField} يجب ان يتساوى مع {thatField}'
    },

    views: {
      common: {
        listView: {
          quickView: 'عرض سريع',
          allItems: 'جميع العناصر',
          deletedItems: 'المحذوفات',
          view: 'عرض',
          edit: 'تعديل',
          selectedRows: {
            options: 'خيارات المواد المحددة',
            delete: 'مسح المواد المحددة',
            deleteConfirm: 'يرجى التأكيد على مسح المواد المحددة',
            deleteSuccess: 'تم مسح المواد المحددة بنجاح',
            export: 'تصدير المواد المحددة',
            exportSuccess: 'تم تصدير المواد المحددة بنجاح',
            restore: 'استرجاع العناصر المحددة',
            restoreConfirm: 'يرجى التأكيد على استرجاع المواد المحددة',
            restoreSuccess: 'تم استرجاع العناصر المحددة بنجاح',
            deletePermanently: 'حذف نهائي',
            deletePermanentlyConfirm: 'يرجى التأكيد على حذف المواد المحددة بشكل نهائي',
            deletePermanentlySuccess: 'تم حذف المواد المحددة بشكل نهائي بنجاح'
          },

          searchRows: 'ابحث...',

          count: 'العدد الكلي'
        }
      },

      backups: {
        backups: "النسخ الاحتياطية",
        backupName: "اسم النسخة",
        downloadBackup: "تحميل نسخة",
        deleteBackup: "حذف النسخة",
        createBackup: "انشاء نسخة"
      },

      home: {
        home: 'الرئيسية'
      },

      login: 'تسجيل الدخول',

      sales: {
        sales: 'المبيعات',
        newSale: 'بيع جديد',
        orderPayment: 'تسديد فاتورة',
        orders: {
          orders: 'الطلبات',
          order: 'الفاتورة',
          returnOrder: 'ارجاع المبيعات',
          orderPayment: 'الدفع'
        },
        receipt: 'الفاتورة',
        registers: {
          openRegister: 'فتح الصندوق',
          closeRegister: 'غلق الصندوق'
        },
        quotes: {
          quotes: 'عروض الأسعار'
        },
        transactions: {
          transactions: 'العمليات'
        }
      },

      inventory: {
        inventory: 'المخزن',

        items: {
          items: 'المنتجات',
          newSimpleItem: 'اضافة منتج',
          simpleItem: 'تعديل منتج',
          import: 'استيراد المنتجات',
          itemBatches: 'الوجبات',
        },

        transactions: {
          transactions: 'حركات المخزن',
        },

        brands: {
          brands: 'العلامات التجارية',
          newBrand: 'اضافة علامة تجارية',
          brand: 'تعديل علامة تجارية'
        },

        customPrice: {
          customPrices: 'الاسعار الاخرى',
          newCustomPriceType: 'اضافة نوع جديد'
        },

        packs: {
          packs: 'الرزم',
          newPack: 'اضافة رزمة جديدة'
        },

        attribute: {
          attributes: 'الاصناف',
          newAttribute: 'اضافة صنف جديدة'
        },

        categories: {
          categories: 'المجاميع',
          newCategory: 'اضافة مجموعة',
          category: 'تعديل مجموعة'
        },

        tags: {
          tags: 'الوسوم',
          newTag: 'اضافة وسم',
          tag: 'تعديل وسم'
        },

        inventoryReceivings: {
          inventoryReceivings: 'استلام بضاعة',
          newInventoryReceiving: 'استلام بضاعة جديدة',
          inventoryReceiving: 'عرض استلام بضاعة'
        },

        inventoryAdjustments: {
          inventoryAdjustments: 'تعديل البضاعة',
          newInventoryAdjustment: 'تعديل بضاعة جديد',
          inventoryAdjustment: 'عرض تعديل البضاعة'
        },

        missingSerials: {
          missingSerials: 'الارقام التسلسلية المفقودة',
        },

        itemBatches: {
          itemBatches: 'الوجبات',
        },

        purchaseOrders: {
          purchaseOrders: 'طلبات الشراء',
          newPurchaseOrder: 'طلب شراء جديد',
        },

        inventoryTransfers: {
          inventoryTransfers: 'نقل البضاعة',
          newInventoryTransfer: 'انشاء نقل بضاعة',
          receiveInventoryTransfer: 'استلام بضاعة منقولة',
          inventoryTransfer: 'عرض نقل البضاعة'
        },

        inventoryReturnToVendors: {
          inventoryReturnToVendors: 'ارجاع البضاعة'
        },

        printBarcode: {
          printBarcode: 'طباعة الباركودات'
        }
      },

      customers: {
        customers: 'الزبائن',
        newCustomer: 'اضافة زبون',
        editCustomer: 'تعديل زبون',
        customer: 'تعديل زبون',
        birthdays: 'اعياد الميلاد',
        documentation: 'الملاحظات',
        notes: {
          notes: 'الملاحظات',
        },
      },

      pets: {
        pets: 'الحيوانات الأليفة',
        newPet: 'أليف جديد',
        pet: 'تعديل أليف',
        viewPet: 'عرض أليف'
      },

      vets: {
        newVetService: 'خدمة بيطرية جديدة',
      },

      vetServices: {
        vetServices: 'خدمات بيطرية',
        newVetService: 'خدمة بيطرية جديدة',
        vetService: 'تعديل خدمة بيطرية'
      },

      examinations: {
        examinations: 'الفحوصات',
        newExamination: 'فحص جديد',
        zeissCards: 'بطاقات ZEISS',
        newZeissCard: 'بطاقة ZEISS جديدة',
        zeissCardsPage: {
          settings: 'الإعدادات',
          newCard: 'بطاقة جديدة'
        }
      },

      appointments: {
        appointments: 'المواعيد',
        newAppointment: 'موعد جديد'
      },

      companies: {
        companies: 'الشركات',
        vendors: {
          vendors: 'الموردون',
        },
        deliveries: {
          deliveries: 'التوصيل',
        },
      },

      vendors: {
        vendors: 'المورّدون',
        newVendor: 'اضافة مورّد',
        vendor: 'تعديل مورّد'
      },

      insurances: {
        insurances: 'التأمين الصحي',
        newInsurance: 'اضافة شركة تأمين',
        insurance: 'تعديل شركة تأمين'
      },

      deliveries: {
        deliveries: 'التوصيل',
        newDelivery: 'اضافة شركة توصيل',
        delivery: 'تعديل شركة توصيل'
      },


      hr: {
        hr: 'الموارد البشرية',
        viewSchedule: 'جدول المناوبات',
        assignShift: 'تعيين مناوبة عمل',
        employees: {
          employees: 'الموظفين',
          newEmployee: 'اضافة موظف'
        },
        roles: {
          roles: 'الادوار'
        },
        commissions: {
          commission: 'العمولة',
          newCommission: 'اضافة عمولة جديدة'
        },
        moneyCollectorCommissions: {
          moneyCollectorCommissions: 'عمولات الجباة',
          new: 'اضافة عمولة جامع أموال'
        },
        employeeSchedule: {
          employeeSchedule: 'جدول الموظفين',
          newEmployeeSchedule: 'تعيين مناوبة عمل'
        },
        tasks: {
          tasks: 'المهام',
        },
        employeeSchedules: {
          newEmployeeSchedule: 'تعيين مناوبة عمل',
        },
        clockInOut: 'تسجيل الدخول/الخروج',
        myTasks: 'مهامي'
      },

      accounting: {
        accounting: 'المحاسبة',

        accounts: {
          accounts: 'الحسابات',
          account: 'عرض الحساب',
          newAccount: 'حساب جديد'
        },

        transactions: {
          transactions: 'الحركات المالية',
          transaction: 'عرض حركة مالية',
          newTransaction: 'تسجيل حركة مالية'
        },

        vendors: {
          newBill: 'فاتورة جديدة'
        },
        company: {
          company: 'الشركة',
          newExpense: 'ادخال مصروف جديد'
        },
        safesAndBanks: {
          safesAndBanks: 'الخزنات والبنوك',
        },
      },

      reports: {
        reports: 'التقارير',
        agGridToolbar: {
          fromDate: 'من',
          toDate: 'الى'
        },
        emptyState: 'قم بتجربة متجر اخر او تاريخ مختلف',
        salesSummary: {
          salesSummaryNoSales: {
            title: 'عدد مبيعات وترجيعات اليوم',
            noOfSales: 'عدد المبيعات',
            noOfReturns: 'عدد الترجيعات'
          },
          salesSummaryValues: {
            title: 'القيمة المالية لمبيعات وترجيعات اليوم',
            totalSales: 'قيمة المبيعات',
            totalReturns: 'قيمة الترجيعات',
            netSales: 'Net Sales'
          }
        }
      },

      settings: {
        settings: 'الاعدادات',
        tabs: {
          printers: 'الطابعات',
          receipt: 'حجم الوصولات',
          currencies: 'سعر التصريف',
          language: 'اللغة',
          license: 'الرخصة',
          sales: 'المبيعات'
        }
      },

      notifications: {
        title: 'اشعارات',
        unread: 'غير مقروء',
        empty: 'لا توجد اشعارات اليوم',
        allCaughtUp: 'لقد اطلعت على جميع الاشعارات',
        loadMore: 'تحميل المزيد',
        noneForDay: 'لا توجد إشعارات لهذا اليوم',
        markAllRead: 'اعتبر الجميع مقروء',
        viewAll: 'عرض جميع الاشعارات',
        all: 'الكل',
        read: 'مقروء',
        reminders: 'تذكيرات',
        searchPlaceholder: 'بحث في الاشعارات',
        types: {
          appointment: 'موعد',
          task: 'مهمة',
          birthday: 'عيد ميلاد',
          quote: 'عرض سعر',
          reminder: 'تذكير',
          order_due: 'طلب مستحق الدفع'
        },
        repeat: {
          none: 'بدون تكرار',
          hourly: 'كل ساعة',
          daily: 'يومياً',
          weekly: 'أسبوعياً',
          monthly: 'شهرياً'
        },
        reminder: {
          addTitle: 'إضافة تذكير',
          editTitle: 'تعديل تذكير',
          titleLabel: 'العنوان',
          noteLabel: 'ملاحظة',
          dateTimeLabel: 'التاريخ والوقت',
          repeatLabel: 'التكرار',
          markDone: 'تم',
          delete: 'حذف',
          deleteConfirm: 'حذف هذا التذكير؟'
        }
      }
    },

    dialogs: {
      warning: 'تحذير',
      confirm: 'تأكيد',
      cancel: 'الغاء',
      completePay: 'أتمام الدفع',
      enterCashierPin: 'ادخل رمز الكاشير الخاص بك',
      errCashierPinRequired: 'يرجى ادخال رمز الكاشير لاتمام البيع',
      confirmAction: 'هل انت متأكد؟',
      msgUpdated: 'تم التحديث',
    },
    update: 'تحديث',
    components: {
      tagInput: {
        placeholder: 'اضغط Enter بعد اضافة كل قيمة'
      }
    }
  }
}
